var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"downloadable-item",attrs:{"href":_vm.href,"download":"","title":`Download ${_vm.name}`}},[_c('base-svg',{attrs:{"name":"download"}}),_c('base-font',{staticClass:"downloadable-text",attrs:{"variant":"paragraph","weight":"bold","uppercase":""}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }